import { z } from 'zod'

export const exchangeRateResponseSchema = z.object({
  baseCurrency: z.string(),
  date: z.string(), // ISO date string YYYY-MM-DD
  rates: z.record(z.string(), z.number()),
})

export type ExchangeRateResponseDto = z.infer<typeof exchangeRateResponseSchema>

export const currencyPairsResponseSchema = z.object({
  date: z.string(),
  pairs: z.record(z.string(), z.number()),
})

export type CurrencyPairsResponseDto = z.infer<typeof currencyPairsResponseSchema>
